export const AUTH_EDIT = "AUTH_EDIT";
export const REMOVE_TOKEN = "REMOVE_TOKEN";
export const SET_AUTH_DATA = "SET_AUTH_DATA";
export const VERIFY_EMAIL = "VERIFY_EMAIL";
